import React from "react";
import { useNavigate } from "react-router-dom";
import Spinner from "Common/Globle/Spinner";

import useFormChange from "Hooks/useFormChange";
import useFormSubmit from "Hooks/useFormSubmit";

import { validateForm } from "utils/validation";

import { SubscriberAddRules } from "validation/ValidationRules";

import fields from "../json/SubscribeEmailList.json";

import AddSubscriberForm from "./Components/AddSubscriberForm";

import { Create } from "adminApi/SubscribeEmailListApi/SubscribeEmailList";

const SubscriberAdd = () => {
  const navigate = useNavigate();

  const { formdata } = fields;

  const initialValues = formdata.reduce(
    (acc, field) => ({
      ...acc,
      [field.name]: "",
    }),
    {}
  );

  const {
    values,
    errors,
    handleChange,
    setErrors,
  } = useFormChange(initialValues, SubscriberAddRules);

  const { loading: loadingSubmit, handleSubmit } =
    useFormSubmit(
      async (formValues) => {
        const formData = new FormData();

        Object.entries(formValues).forEach(([key, val]) =>
          formData.append(key, val ?? "")
        );

        return await Create({
          data: formData,
        });
      },
      (vals) => {
        const err = validateForm(vals, SubscriberAddRules);
        console.log("Validation errors:", err);
        setErrors(err);
        return err;
      },
      () => navigate(-1),
      "Member added successfully"
    );

  return (
    <>
      {loadingSubmit && <Spinner isSpinner={true} />}

      <AddSubscriberForm
        values={values}
        errors={errors}
        handleChange={handleChange}
        handleSubmit={(e) => handleSubmit(e, values)}
        loading={loadingSubmit}
      />
    </>
  );
};

export default SubscriberAdd;